"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataStringValues = exports.DataStringFunctions = void 0;
exports.isDataStringFunctions = isDataStringFunctions;
class DataStringValues {}
exports.DataStringValues = DataStringValues;
class DataStringFunctions {}
exports.DataStringFunctions = DataStringFunctions;
function isDataStringFunctions(it) {
  var _Object$values;
  if (!it) {
    return false;
  }
  let val = (_Object$values = Object.values(it)) === null || _Object$values === void 0 ? void 0 : _Object$values[0];
  return val && typeof val === "object" && "value" in val && typeof val.value === "function";
}
//# sourceMappingURL=DumbappValueFunction.js.map